import { getName } from '@esentai/core/features/brands/selectors';
import { withStyles } from '@material-ui/core';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import BrandTitle from './component';
import styles from './styles';

const mapStateToProps = (state, { brandId }) => ({
  name: getName(state, brandId),
});

export default compose(
  connect(mapStateToProps),
  withStyles(styles),
)(BrandTitle);
